// extracted by mini-css-extract-plugin
export var brand = "_2m-9";
export var compact = "_2m-6";
export var extraSmall = "_2m-7";
export var icon = "_2m-0";
export var large = "_2m-4";
export var light = "_2m-1";
export var medium = "_2m-5";
export var outline = "_2m-b";
export var primaryDark = "_2m-a";
export var primaryLight = "_2m-8";
export var primaryModern = "_2m-c";
export var success = "_2m-2";
export var successSolid = "_2m-3";